import React, { useState, useEffect } from 'react';
import { getTemplates, getTemplate, updateTemplate } from '../utils/api';

export default function TemplateEditor() {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [form, setForm] = useState({ name: '', subject: '', htmlBody: '' });
  const [saving, setSaving] = useState(false);
  const [preview, setPreview] = useState(false);

  useEffect(() => { getTemplates().then(setTemplates).catch(console.error); }, []);

  const load = async (tpl) => {
    const full = await getTemplate(tpl.SK || tpl.templateId);
    setSelected(full);
    setForm({ name: full.name, subject: full.subject, htmlBody: full.htmlBody });
    setPreview(false);
  };

  const save = async () => {
    setSaving(true);
    try {
      const id = selected.SK || selected.templateId;
      await updateTemplate(id, form);
      alert('Template saved!');
      setTemplates(await getTemplates());
    } catch (err) { alert(err.message); }
    setSaving(false);
  };

  const inputStyle = { width: '100%', padding: 8, marginBottom: 8, boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: 4 };

  return (
    <div>
      <h2 style={{ margin: '0 0 16px' }}>✉️ Email Templates</h2>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {templates.map(t => (
          <button key={t.SK || t.templateId} onClick={() => load(t)}
            style={{ padding: '6px 14px', background: selected?.templateId === t.templateId ? '#0073bb' : '#e0e0e0', color: selected?.templateId === t.templateId ? '#fff' : '#333', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}>
            {t.name} {t.userId === 'system' ? '(system)' : ''}
          </button>
        ))}
      </div>

      {selected && (
        <div style={{ border: '1px solid #ddd', borderRadius: 8, padding: 16 }}>
          <input placeholder="Template name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={inputStyle} />
          <input placeholder="Subject line (supports {{dashboardName}}, {{startDate}}, {{endDate}})" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} style={inputStyle} />
          <p style={{ fontSize: 12, color: '#666', margin: '0 0 4px' }}>
            Variables: {'{{dashboardName}}'}, {'{{industry}}'}, {'{{role}}'}, {'{{startDate}}'}, {'{{endDate}}'}, {'{{#items}}...{{/items}}'} with {'{{score}}'}, {'{{title}}'}, {'{{link}}'}, {'{{reason}}'}, {'{{publishedAt}}'}, {'{{scoreColor}}'}
          </p>
          <textarea value={form.htmlBody} onChange={(e) => setForm({ ...form, htmlBody: e.target.value })}
            style={{ ...inputStyle, minHeight: 300, fontFamily: 'monospace', fontSize: 12 }} />
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={save} disabled={saving}
              style={{ padding: '8px 24px', background: '#0073bb', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
              {saving ? 'Saving...' : 'Save Template'}
            </button>
            <button onClick={() => setPreview(!preview)}
              style={{ padding: '8px 24px', background: '#545b64', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
              {preview ? 'Hide Preview' : 'Preview'}
            </button>
          </div>
          {preview && (
            <div style={{ marginTop: 12, border: '1px solid #ddd', borderRadius: 4, overflow: 'hidden' }}>
              <iframe title="preview" srcDoc={form.htmlBody} style={{ width: '100%', height: 500, border: 'none' }} />
            </div>
          )}
        </div>
      )}

      {!selected && templates.length > 0 && <p style={{ color: '#666' }}>Select a template to edit.</p>}
      {templates.length === 0 && <p style={{ color: '#666' }}>No templates found.</p>}
    </div>
  );
}
